import { Component, Input, EventEmitter, Output, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/dashboard/i18n/scope";
import { DashboardModel } from "../shared/models/DashboardModel";
import { DashboardService } from "../services/dashboard.service";
import { IdNameDescriptionModel } from "@models/generic/IdNameDescriptionModel";
import { DashboardPermissionModel } from "@models/permissions/DashboardPermissionModel";
import { PermissionsService } from "@services/permissions/PermissionsService";
import { CerrixTextfieldComponent } from "@app/shared/components/cerrix-textinput/cerrix-textfield/cerrix-textfield.component";
import { CerrixTextAreaComponent } from "@app/shared/components/cerrix-textinput/cerrix-textarea/cerrix-textarea.component";
import { CerrixIconPickerComponent } from "@app/shared/components/cerrix-icon-picker/cerrix-icon-picker.component";
import { CheckboxComponent } from "@app/shared/cerrix-checkbox/cerrix-checkbox.component";

@Component({
    selector: "dashboard-configuration",
    templateUrl: "./dashboard-configuration.component.html",
    styleUrls: ["./dashboard-configuration.component.scss"],
    viewProviders: [provideTranslationScope(scope)],
    imports: [
        FormsModule,
        NgSelectModule,
        MatTooltipModule,
        TranslatePipe,
        CerrixTextfieldComponent,
        CerrixTextAreaComponent,
        CerrixIconPickerComponent,
        CheckboxComponent,
    ],
})
export class DashboardConfigurationComponent {
    @Input() config: DashboardModel;
    @Output() changed = new EventEmitter<never>();

    roleGroups: IdNameDescriptionModel[];
    permissions: DashboardPermissionModel;

    private ds = inject(DashboardService);
    private permService = inject(PermissionsService);

    constructor() {
        this.permissions = this.permService.permissions.Dashboard;
        if (this.permissions.RoleGroupLinker) {
            this.ds.getRoleGroups().subscribe((rg) => (this.roleGroups = rg));
        }
    }

    emitChange() {
        this.changed.emit();
    }

    defaultChanged(newValue: boolean) {
        if (newValue) {
            this.config.favorite = true;
        }
    }
}
